import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";

import { fetchCategories } from "@/lib/queries";
import { Skeleton } from "@/components/ui/skeleton";

export const Route = createFileRoute("/categories")({
  head: () => ({
    meta: [
      { title: "Story categories — Quibblies" },
      {
        name: "description",
        content:
          "Browse Quibblies by category — fantasy, romance, horror, literary fiction and more, all reviewed before publication.",
      },
      { property: "og:title", content: "Story categories — Quibblies" },
      {
        property: "og:description",
        content: "Find your next read by genre on Quibblies.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: CategoriesPage,
});

function CategoriesPage() {
  const categories = useQuery({ queryKey: ["categories"], queryFn: fetchCategories });

  return (
    <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6">
      <h1 className="font-display text-4xl text-foreground">Categories</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        Pick a shelf and start browsing.
      </p>

      <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.isLoading
          ? Array.from({ length: 6 }).map((_, index) => (
              <Skeleton key={index} className="h-28 rounded-2xl" />
            ))
          : (categories.data ?? []).map((category) => (
              <Link
                key={category.id}
                to="/discover"
                search={{ category: category.slug }}
                className="group rounded-2xl border border-border/70 bg-gradient-card p-6 transition-smooth hover:-translate-y-1 hover:border-primary/50 hover:shadow-lift"
              >
                <h2 className="font-display text-xl text-foreground">{category.name}</h2>
                <p className="mt-2 text-sm text-muted-foreground">{category.description}</p>
              </Link>
            ))}
      </div>
    </div>
  );
}
